import { createApp } from 'vue';
import MapLocation from './MapLocation.vue';

export const initStaticGoogleMap = () => {
  if (document.getElementById('static-google-map-app')) {
    createApp(MapLocation)
      .mount('#static-google-map-app');
  }
};
